import descriptionValidator from '../../../../../@shared/descriptionValidator';
import useDialog from '../../../../../@shared/Dialogs/useDialog';
import useRequestForm from '../../../../../@shared/Forms/RequestForm/useRequestForm';
import LoadingModal from '../../../../auth/features/ForgotDialogues/LoadingModal';
import boxesEndpoints from '../../../box.endpoints';
import { BoxMovementCode } from '../../../box.models';
import SolicitationFormDialogPresentation from '../solicitationDialog';
import useBoxDataGridSlice from '../useBoxDataGrid';

const SolicitExclusionFormDialog = () => {
  const boxDataGridRedux = useBoxDataGridSlice();

  const { showSolicitExclusionFormDialog, selectedRows } = boxDataGridRedux.useSelector();

  const form = useRequestForm({
    validatorSchema: descriptionValidator,
    submitRequest: (obj) =>
      boxesEndpoints.solicitMovement(
        obj.description,
        selectedRows,
        BoxMovementCode.SolicitExclusion
      ),
  });
  const dialog = useDialog({
    handleOpen: () => boxDataGridRedux.openSolicitExclusionDialog(),
    handleClose: () => boxDataGridRedux.closeSolicitExclusionDialog(),
  });

  form.useHandleSuccess(() => {
    boxDataGridRedux.setAnySubmit(form.submitResponse.success);
    form.submitResponse.reset();
  });

  dialog.useOpen(showSolicitExclusionFormDialog);
  dialog.useClose(form.submitResponse.success);

  if (form.submitResponse.loading) return <LoadingModal />;
  return (
    <SolicitationFormDialogPresentation
      descriptions={selectedRows}
      control={form.control}
      title="Solicitação para exclusão"
      onHide={() => dialog.close()}
      show={dialog.show}
      size="lg"
      method="post"
      onSubmit={form.handleSubmit(form.onSubmit)}
      validated={form.validator.validated}
      errors={form.validator.errors}
    />
  );
};
export default SolicitExclusionFormDialog;
